export const regexNumber = /^(?:[0-9]*)?$/

export const regexAlphaNumericSpacesCommaDot = /^[a-zA-Z0-9,.-\s]*$/

// Regex Alpha
export const regexAlpha = /[a-zA-Z]/

export const regexUrl = /(https?:\/\/[^\s]+)/g
